angular.module('cpm').config(($routeProvider) => {
    'use strict';
    $routeProvider
        .when('/asset-library', {
            templateUrl: 'asset-library/asset-library-pane.html',
            controller: 'AssetLibraryCtrl',
            role: 'USER',
            title: 'Asset Library',
            reloadOnSearch: false
        });
});
